import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import SvcAsesmenKemoterapi from "@/services/AsesmenKemoterapi";

@Module({ dynamic: true, namespaced: true, store, name: "asesmenKemoterapi" })
class AsesmenKemoterapi extends VuexModule {
  dataAsesmenKemoterapi = {};
  loading = false;

  @Mutation
  SET_ASESMEN_KEMOTERAPI(dataAsesmenKemoterapi: {}) {
    this.dataAsesmenKemoterapi = dataAsesmenKemoterapi;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async getAsesmenKemoterapiByReg(reg): Promise<void> {
    this.SET_ASESMEN_KEMOTERAPI(null)
    const dt = await SvcAsesmenKemoterapi.getByReg(
      reg
    ).finally(() => {
    });
    this.SET_ASESMEN_KEMOTERAPI(dt.data ? dt.data : null);
  }

  @Action reset() {
    this.SET_ASESMEN_KEMOTERAPI(null)
  }
}

export default getModule(AsesmenKemoterapi);
